import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../contexts/SettingsContext';

const MetaTags = () => {
  const location = useLocation();
  const { settings, isLoading } = useSettings();

  useEffect(() => {
    if (isLoading) return;

    // Valeurs par défaut
    const siteName = settings.siteName || 'MedAgriCycle';
    const siteDescription = settings.siteDescription || 'Plateforme d\'innovation agricole méditerranéenne';

    // Mettre à jour le titre de la page
    const updateTitle = () => {
      const path = location.pathname;
      let pageTitle = siteName;

      if (path === '/') {
        pageTitle = `${siteName} | Accueil`;
      } else if (path === '/about') {
        pageTitle = `${siteName} | À propos`;
      } else if (path === '/contact') {
        pageTitle = `${siteName} | Contact`;
      } else if (path === '/news') {
        pageTitle = `${siteName} | Actualités`;
      } else if (path === '/events') {
        pageTitle = `${siteName} | Événements`;
      } else if (path.startsWith('/news/')) {
        pageTitle = `${siteName} | Actualité`;
      } else if (path.startsWith('/events/')) {
        pageTitle = `${siteName} | Événement`;
      } else if (path.startsWith('/admin')) {
        pageTitle = `${siteName} | Administration`;
      }

      document.title = pageTitle;
    };

    // Mettre à jour les meta tags
    const updateMetaTags = () => {
      // Meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', siteDescription);

      // Open Graph
      const updateOGTag = (property, content) => {
        let tag = document.querySelector(`meta[property="${property}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute('property', property);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
      };

      updateOGTag('og:title', `${siteName} | ${siteDescription}`);
      updateOGTag('og:description', siteDescription);
      updateOGTag('og:site_name', siteName);
      updateOGTag('og:url', window.location.href);

      // Twitter Card
      const updateTwitterTag = (name, content) => {
        let tag = document.querySelector(`meta[name="${name}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute('name', name);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
      };

      updateTwitterTag('twitter:title', `${siteName} | ${siteDescription}`);
      updateTwitterTag('twitter:description', siteDescription);
    };

    updateTitle();
    updateMetaTags();
  }, [location.pathname, settings, isLoading]);

  return null; // Ce composant ne rend rien
};

export default MetaTags;

